import { Flex } from 'antd';
import { memo, useContext } from 'react';

import { ButtonVariant, Button, Modal, Typography } from '@/shared/ui';

import ModalContext from '../../../contexts/Modal/ModalContext';

import './LeavingWhileInProgressAlert.scss';

export interface LeavingWhileInProgressAlertProps {
  onStay?: () => void;
  onLeave?: () => void;
}

export const LeavingWhileInProgressAlert = memo<LeavingWhileInProgressAlertProps>(function ({ onStay, onLeave }) {
  const { toggleModal, isModalOpen } = useContext(ModalContext);

  return (
    <Modal
      closable
      size="md"
      title="Ви в процесі створення заявки"
      open={isModalOpen}
      footer={
        <Flex gap={8}>
          <Button
            variant={ButtonVariant.PRIMARY}
            onClick={(): void => {
              toggleModal();
              onStay && onStay();
            }}
          >
            Продовжити створення
          </Button>
          <Button
            variant={ButtonVariant.SECONDARY}
            onClick={(): void => {
              toggleModal();
              onLeave && onLeave();
            }}
          >
            <Typography color="red">Скасувати створення</Typography>
          </Button>
        </Flex>
      }
      onCancel={(): void => {
        toggleModal();
        onStay && onStay();
      }}
    >
      <Typography variant="TEXT16">Для того, щоб створити нову заявку, треба скасувати створення поточної.</Typography>
    </Modal>
  );
});
